export function formatLeaseRemaining(leaseExpiresAt: string | null): string | null {
	if (!leaseExpiresAt) return null;
	const ms = new Date(leaseExpiresAt).getTime() - Date.now();
	if (ms <= 0) return 'reclaim ожидается';
	const sec = Math.ceil(ms / 1000);
	if (sec < 60) return `${sec}с`;
	return `${Math.ceil(sec / 60)}м`;
}
